<div class="mydocma-section-header" style="height: 52px;" mydocmaResizeEvent (resize)="!deviceService.isMobil() ? onResize($event) : null" [ngStyle]="(platformModeStateService.isLocalMode$ | async) ? {'background-color': 'var(--mydocma-color-peach1)'} : {}">
  <span class="header-item faults-label">{{'MM.fault.faultPlural' | translate}}</span>
  <div style="flex:1; display: flex; align-items: center; height: 100%; min-width: 0px;">
    <div *ngIf="showStroke && filterState.structure && this.filterState.structure.Id !== this.filterState.project.Structure.Id" style="width: 1.5px; height: 20px; margin: 0px 16px; background-color: var(--mydocma-color-grey1);"></div>
    <mydocma-chip-list class="structure-chiplist" [style]="deviceService.isMobil ? 'margin-left: 8px' : ''" [chips]="(currentStructure$ | async)" [options]="currentStructureChipOptions" *ngIf="filterState.structure && this.filterState.structure.Id !== this.filterState.project.Structure.Id"></mydocma-chip-list>
  </div>
  <div style="display: flex; align-items: center; width: auto; margin: 0px; padding: 0px">
    <mydocma-new-fab #ref *ngIf="(permissionNewFault$  | async)" [button]="(fabButton$ | async)"
      class="header-item mydocma-mm-action-new">
    </mydocma-new-fab>
    <div *ngIf="!showTabletMeatballMenu; else meatballMenu" style="display: flex; align-items: center; width: auto; margin: 0px; padding: 0px;">
       <mydocma-toggle-group *ngIf="(!(connectivityService.isOffline | async) || platformModeStateService.isLocalModeEnabled) && !deviceService.isMobil()" class="header-item"
        [items]="toggleGroupItems1" [selectedItem]="selectedItem1" (groupItemClicked)="onGroupToggleItemClicked($event, toggleItemsGroupEnum.First)">
      </mydocma-toggle-group>
       <mydocma-toggle-group *ngIf="!deviceService.isMobil() && (!(connectivityService.isOffline | async) || platformModeStateService.isLocalModeEnabled)"  class="header-item"
        [items]="toggleGroupItems2" [selectedItem]="selectedItem2" (groupItemClicked)="onGroupToggleItemClicked($event, toggleItemsGroupEnum.Second)">
      </mydocma-toggle-group>
       <mydocma-toggle-group
       *ngIf="!(connectivityService.isOffline | async) && !deviceService.isMobil() && (modelAvailabilityService.isBimIntegrationEnabled$ | async) && (this.filterState.project?.BPConnected ?? false)"
        class="header-item"
        [items]="toggleGroupItems3" [selectedItem]="selectedItem3" (groupItemClicked)="onGroupToggleItemClicked($event, toggleItemsGroupEnum.Third)">
      </mydocma-toggle-group>

      <button style="margin-left: auto;" mat-icon-button (click)="toggleSelectionMode()"
        matTooltip="{{'MM.general.button.selection-mode' | translate}}" [disabled]="false">
        <mydocma-custom-mat-icon *ngIf="!(this.selectionService.selectionMode | async)"
          [iconName]="'_multiselect-mode-default-with-colors'" style="display: inline-flex"></mydocma-custom-mat-icon>
        <mydocma-custom-mat-icon *ngIf="!!(this.selectionService.selectionMode | async)"
          [iconName]="'_multiselect-mode-selected'" style="display: inline-flex"></mydocma-custom-mat-icon>
      </button>
      <button mat-icon-button [matMenuTriggerFor]="sortMenu"
        matTooltip="{{'MM.fault.sortBy' | translate}}" [disabled]="false">
        <mat-icon>sort</mat-icon>
      </button>
      <button style="margin-left: auto;" *ngIf="'false'" mat-icon-button (click)="emitRefreshFaults()"
        matTooltip="{{'MM.general.button.refresh' | translate}}" [disabled]="false">
        <mat-icon>sync</mat-icon>
      </button>
    </div>
  </div>

  <ng-template #meatballMenu>
    <button mat-icon-button
      [matMenuTriggerFor]="tabletHeaderMenu"
      style="line-height: 24px; width: 24px; height: 24px; margin: 0px 10px;"
      (click)="$event.stopPropagation()">
      <mydocma-custom-mat-icon [iconName]="'more_horiz'"></mydocma-custom-mat-icon>
    </button>

    <mat-menu #tabletHeaderMenu="matMenu">
      <button mat-menu-item class="grid-view-button-tablet" [mat-menu-trigger-for]="gridMultilineDropdown" (menuOpened)="onSubMenuOpened()" (click)="faultsSplitService.toggleView(headerToggleMenuEnum.gridView)">
        <mydocma-custom-mat-icon [iconName]="'view_headline'"></mydocma-custom-mat-icon>
        {{  'MM.fault.gridView' | translate }}
        <ng-container *ngIf="faultsSplitService.toggledLeftViews?.includes('gridView'); then doneIcon"></ng-container>
      </button>
      <button mat-menu-item (click)="faultsSplitService.toggleView(headerToggleMenuEnum.tileView)">
        <mydocma-custom-mat-icon [iconName]="'view_module'"></mydocma-custom-mat-icon>
        {{  'MM.fault.tilesView' | translate }}
        <ng-container *ngIf="faultsSplitService.toggledLeftViews?.includes('tileView'); then doneIcon"></ng-container>
      </button>
      <button mat-menu-item (click)="faultsSplitService.toggleView(headerToggleMenuEnum.planView)"  style="border-bottom: 1px solid var(--mydocma-color-grey3);">
        <mydocma-custom-mat-icon [iconName]="'_plan-view'"></mydocma-custom-mat-icon>
        {{  'MM.fault.planView' | translate }}
        <ng-container *ngIf="faultsSplitService.toggledRightViews?.includes('planView'); then doneIcon"></ng-container>
      </button>
      <button mat-menu-item (click)="toggleSelectionMode()">
        <mydocma-custom-mat-icon [iconName]="'_multiselect-mode-default-with-colors'"></mydocma-custom-mat-icon>
        {{  'MM.general.button.selection-mode' | translate }}
        <ng-container *ngIf="!!(this.selectionService.selectionMode | async); then doneIcon"></ng-container>
      </button>
      <button mat-menu-item [matMenuTriggerFor]="sortMenu" (menuOpened)="onSortMenuOpened()">
        <mat-icon>sort</mat-icon>
        {{ 'MM.fault.sortBy' | translate }}
      </button>
      <button mat-menu-item (click)="emitRefreshFaults()">
        <mydocma-custom-mat-icon [iconName]="'sync'"></mydocma-custom-mat-icon>
        {{  'MM.general.button.refresh' | translate }}
      </button>
    </mat-menu>
    <ng-template #doneIcon>
      <mydocma-custom-mat-icon
        style="margin-left: 10px" [iconName]="'done'">
       </mydocma-custom-mat-icon>
    </ng-template>
  </ng-template>

  <mat-menu class='multiline-dropdown' #gridMultilineDropdown="matMenu">

      <button mat-menu-item (click)="setNewRowLineAmount(1); faultsSplitService.toggleView(headerToggleMenuEnum.gridView);">
        {{ 'MM.gridMultiline.oneLine' | translate }}
        <ng-container *ngIf="(rowDefsService.gridCurrentLineAmount$ | async) == 1; then doneIcon"></ng-container>
      </button>
      <button mat-menu-item (click)="setNewRowLineAmount(2); faultsSplitService.toggleView(headerToggleMenuEnum.gridView);">
        {{ 'MM.gridMultiline.twoLines' | translate }}
        <ng-container *ngIf="(rowDefsService.gridCurrentLineAmount$ | async) == 2; then doneIcon"></ng-container>
      </button>
      <button mat-menu-item (click)="setNewRowLineAmount(3); faultsSplitService.toggleView(headerToggleMenuEnum.gridView);">
        {{ 'MM.gridMultiline.threeLines' | translate }}
        <ng-container *ngIf="(rowDefsService.gridCurrentLineAmount$ | async) == 3; then doneIcon"></ng-container>
      </button>
      <button mat-menu-item (click)="setNewRowLineAmount(4); faultsSplitService.toggleView(headerToggleMenuEnum.gridView);">
        {{ 'MM.gridMultiline.fourLines' | translate }}
        <ng-container *ngIf="(rowDefsService.gridCurrentLineAmount$ | async) == 4; then doneIcon"></ng-container>
      </button>
   </mat-menu>

   <ng-template #doneIcon>
    <mydocma-custom-mat-icon
      style="margin-left: 10px" [iconName]="'done'">
     </mydocma-custom-mat-icon>
  </ng-template>

  <mat-menu class='sorting-dropdown' #sortMenu="matMenu">
    <div class="sort-criteria-group">
      <ng-container *ngFor="let criterion of availableCriteria">
        <div mat-menu-item class="sort-criteria-item"
          (click)="onSortCriterionClick(criterion)"
          [disabled]="criterion === sortCriterionEnum.List && !hasLayoutSorting">
          <p class="sort-criteria-item-text">{{ getCriterionLabel(criterion) }}</p>
          <mat-icon
            *ngIf="shouldShowCriterionCheckmark(criterion)"
            class="sort-criteria-item-icon">check
          </mat-icon>
        </div>
      </ng-container>
    </div>
    <div class="sort-divider"></div>
    <div class="sort-direction-group">
      <div mat-menu-item class="sort-direction-item"
        (click)="onSortDirectionClick(sortDirectionEnum.Ascending)"
        [class.disabled]="currentSortState?.criterion == null">
        <p class="sort-direction-item-text">{{ 'MM.fault.ascending' | translate }}</p>
        <mat-icon
          *ngIf="shouldShowDirectionCheckmark(sortDirectionEnum.Ascending)"
          class="sort-direction-item-icon">check
        </mat-icon>
      </div>
      <div mat-menu-item class="sort-direction-item"
        (click)="onSortDirectionClick(sortDirectionEnum.Descending)"
        [class.disabled]="currentSortState?.criterion == null">
        <p class="sort-direction-item-text">{{ 'MM.fault.descending' | translate }}</p>
        <mat-icon
          *ngIf="shouldShowDirectionCheckmark(sortDirectionEnum.Descending)"
          class="sort-direction-item-icon">check
        </mat-icon>
      </div>
    </div>
  </mat-menu>
</div>
